import React from "react";
import { useParams } from 'react-router-dom';
import CadastrarCliente from "./CadastrarCliente";


const EditarCliente = () => {
    const { id } = useParams();

    return <CadastrarCliente clienteId={id} />;
};

export default EditarCliente;

